'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import userService from "@/api/userService";
import {encrypt} from "@/utils/crypto";
import subscriptionService from "@/api/subscriptionService";
import router from "@/router";
import activityWatcher from "@/utils/activityWatcher";

export default {
  async getOrganizations() {
    const data = {
      method: 'get',
      url: 'organizations',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getOrganization(id) {
    const data = {
      method: 'get',
      url: 'organizations/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      sessionStorage.setItem('organization', encrypt(JSON.stringify(response.data)))
      return response.data
    }
  },
  async updateOrganization(json, id) {
    const data = {
      method: 'put',
      url: 'organizations/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Organization updated successfully')
      return true;
    }
  },
  async updateOrganizationLogo(json, id) {
    const data = {
      method: 'post',
      url: 'organizations/' + id + '/logo',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Logo updated successfully')
      return true;
    }
  },

  async revokeOrganizationFile(id) {
    const data = {
      method: 'delete',
      url: 'organization-file/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Organization file revoked successfully')
      window.location.reload()
    }
  },

  async sendMassEmail(json) {
    const data = {
      method: 'post',
      url: 'mass-email',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Mass email sent successfully')
      window.location.reload()
    }
  },
}
